import { TmdxAvatar } from '@ds';

type ResourceNameCellProps = {
  fullName: string;
  photoPath?: string;
};

export const ResourceNameCell = ({ fullName, photoPath }: ResourceNameCellProps) => {
  return (
    <div className="flex items-center gap-2">
      <div className="flex flex-col w-14 max-w-14 shrink-0 items-center overflow-hidden">
        <TmdxAvatar className="shrink-0" size="lg" radius="lg" name={fullName} src={photoPath} />
      </div>
      <div className="text-m-m">{fullName}</div>
    </div>
  );
};
